import React from 'react';
import { Helmet } from 'react-helmet-async';
import FeatureBox from '../components/ui/FeatureBox';
import CTASection from '../components/ui/CTASection';
import { aboutContent } from '../content/about';
import './About.css';

const About = () => {
  return (
    <>
      <Helmet>
        <title>من نحن - نمو ماركتينج</title>
        <meta
          name="description"
          content="تعرف على نمو ماركتينج - شريكك في النجاح الرقمي. وكالة تسويق رقمي متخصصة تساعد الشركات على بناء حضور قوي على الإنترنت."
        />
      </Helmet>

      <div className="about-page">
        {/* Hero Section */}
        <section className="page-hero">
          <div className="container">
            <div className="page-hero-content">
              <h1 className="page-hero-title">{aboutContent.hero.title}</h1>
              <p className="page-hero-subtitle">{aboutContent.hero.subtitle}</p>
              <p className="page-hero-description">{aboutContent.hero.description}</p>
            </div>
          </div>
        </section>

        {/* Our Story */}
        <section className="section">
          <div className="container">
            <div className="section-header">
              <h2 className="section-title">{aboutContent.story.title}</h2>
            </div>
            <div className="story-content">
              <p style={{ whiteSpace: 'pre-line', marginBottom: 'var(--spacing-md)' }}>
                {aboutContent.story.content}
              </p>
              <ul className="story-achievements">
                {aboutContent.story.achievements.map((achievement, index) => (
                  <li key={index}>
                    <span className="achievement-icon">✓</span>
                    {achievement}
                  </li>
                ))}
              </ul>
              <p style={{ marginTop: 'var(--spacing-md)', fontStyle: 'italic' }}>
                {aboutContent.story.closing}
              </p>
            </div>
          </div>
        </section>

        {/* Vision & Mission */}
        <section className="section bg-light">
          <div className="container">
            <div className="grid grid-2">
              <div className="vision-mission-card">
                <div className="vm-icon">{aboutContent.vision.emoji}</div>
                <h3 className="vm-title">{aboutContent.vision.title}</h3>
                <p className="vm-description">{aboutContent.vision.description}</p>
              </div>
              <div className="vision-mission-card">
                <div className="vm-icon">{aboutContent.mission.emoji}</div>
                <h3 className="vm-title">{aboutContent.mission.title}</h3>
                <p className="vm-description">{aboutContent.mission.description}</p>
              </div>
            </div>
          </div>
        </section>

        {/* Our Values */}
        <section className="section">
          <div className="container">
            <div className="section-header">
              <h2 className="section-title">{aboutContent.values.title}</h2>
              <p className="section-subtitle">{aboutContent.values.subtitle}</p>
            </div>
            <div className="grid grid-3">
              {aboutContent.values.items.map((value) => (
                <FeatureBox
                  key={value.id}
                  icon={value.icon}
                  title={value.title}
                  description={value.description}
                />
              ))}
            </div>
          </div>
        </section>

        {/* Team Section */}
        <section className="section bg-light">
          <div className="container">
            <div className="section-header">
              <h2 className="section-title">{aboutContent.team.title}</h2>
              <p className="section-subtitle">{aboutContent.team.subtitle}</p>
              <p>{aboutContent.team.description}</p>
              <p style={{ fontSize: 'var(--text-sm)', color: 'var(--gray-500)', marginTop: 'var(--spacing-sm)' }}>
                {aboutContent.team.note}
              </p>
            </div>
          </div>
        </section>

        {/* Final CTA */}
        <CTASection
          title={aboutContent.cta.title}
          subtitle={aboutContent.cta.subtitle}
          buttonText={aboutContent.cta.buttonText}
          backgroundStyle="gradient"
        />
      </div>
    </>
  );
};

export default About;
